import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import AppBarComponent from "./component";

const AppBar = () => {
  const { markdownRemark } = useStaticQuery(query);
  return <AppBarComponent {...markdownRemark.frontmatter} />;
};

const query = graphql`
  query AppBarQuery {
    siteSearchIndex {
      index
    }
    markdownRemark(fileAbsolutePath: { glob: "**/appWidgets/appBar/**" }) {
      frontmatter {
        appBarTitle
        appBarDrawerItems {
          menuLinkLabel
          menuLinkIcon {
            id
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
          menuLinkURL
          openInNewTab
          menuSectionItems {
            menuSectionLabel
            menuSectionIcon {
              id
              publicURL
              childImageSharp {
                gatsbyImageData
              }
            }
            menuSectionURL
            openInNewTab
            menuSubsectionItems {
              menuSubsectionLabel
              menuSubsectionIcon {
                id
                publicURL
                childImageSharp {
                  gatsbyImageData
                }
              }
              menuSubsectionURL
              openInNewTab
            }
          }
        }
        appBarTitleLogo {
          extension
          publicURL
          childImageSharp {
            gatsbyImageData
          }
        }
        appBarSocialItems {
          appBarSocialLinkName
          appBarSocialLinkIcon
          appBarSocialLinkUrl
        }
      }
    }
  }
`;

export default AppBar;
